var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"debounce",rawName:"v-debounce:300ms",value:(_vm.onDone),expression:"onDone",arg:"300ms"},{name:"model",rawName:"v-model",value:(_vm._value),expression:"_value"}],attrs:{"type":"text"},domProps:{"value":(_vm._value)},on:{"input":function($event){if($event.target.composing)return;_vm._value=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }